var _g, _circle, _circle2, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderchats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11_2096)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_2096)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 51,
    width: 77.4,
    height: 64.5,
    rx: 16.125,
    fill: "#E3E4E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6992 86.4746L36.8052 50.1934L120.593 50.1934L78.6992 86.4746Z",
    fill: "#202E5F"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 56.5,
    r: 5,
    stroke: "#202E5F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 102.5,
    r: 3,
    stroke: "#848A9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 109L135.256 113.744L140 115.5L135.256 117.256L133.5 122L131.744 117.256L127 115.5L131.744 113.744L133.5 109Z",
    fill: "#E3E4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 12L36.2556 16.7444L41 18.5L36.2556 20.2556L34.5 25L32.7444 20.2556L28 18.5L32.7444 16.7444L34.5 12Z",
    fill: "#E3E4E9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11_2096",
    x: 19,
    y: 28.5172,
    width: 119.4,
    height: 106.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.48276
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.159429 0 0 0 0 0.0129687 0 0 0 0 0.345833 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_2096"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_2096",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_2096"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 51,
    width: 77.4,
    height: 64.5,
    rx: 16.125,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderchats);
export default __webpack_public_path__ + "static/media/placeholderchats.528bc75f5ab1f1355128fdb280373ab7.svg";
export { ForwardRef as ReactComponent };